module.exports = __webpack_public_path__ + "media/images/icons/chat-popup-close-ae0e75a7160bf9ac433e29386cdbd54b.svg";